// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/chart-distance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/chart-distance/chart-distance.js';
import g1 from '../lessons/navigation/chart-distance/latitude-gap.js';

mount([g0, g1]);
